
import { API_BASE_URL } from "../../config";
import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel
} from "@/components/ui/form"
import { Input } from "@/components/ui/input";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Checkbox } from "@/components/ui/checkbox";


import { Trash2 } from "lucide-react";
import { useApiFetch } from "@/helper/apiFetch";
import { PresentationKeySchema, PresentationSchema } from "./PlenumSchema";
type PresentationInfoProps = {
  Id: number | null;
  plenumId: number ;
  langs: string[];
  eventId: string ;
  onClose: (refresh: boolean) => void;
};










export function PresentationInfo({ Id, plenumId, langs, eventId, onClose }: PresentationInfoProps) {
  const apiFetch = useApiFetch();
  const [isLoaded, setIsLoaded] = useState(false);
  const [errorText, setError] = useState("");
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isUploadingFile, setIsUploadingFile] = useState(false);
  const [uploadingLanguage, setUploadingLanguage] = useState<string | undefined>(undefined);
  const form = useForm<z.infer<typeof PresentationSchema>>({
    resolver: zodResolver(PresentationSchema),
    defaultValues: {
      PlenumId: plenumId,
      EventId: eventId,
      Type: "ispring",
      Keys: []
      
    }
  });





  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setError("");
    const file = e.target.files?.[0];
    if (!file) return;
    e.target.value = "";

    if (!eventId) {
      setError("Missing event id");
      return;
    }

    if (file.size > 20 * 1024 * 1024) {
      setError("File size exceeds 20MB limit");
      return;
    }

    setIsUploadingFile(true);
    try {
      const chunkSize = 200000;
      const totalCount = Math.ceil(file.size / chunkSize);
      const fileGuid = crypto.randomUUID();

      for (let index = 0; index < totalCount; index++) {
        const start = index * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const chunk = file.slice(start, end);

        const fd = new FormData();
        fd.append("myFile", chunk, file.name);

        const metadata = {
          FileName: file.name,
          FileSize: file.size,
          FileType: file.type,
          FileGuid: fileGuid,
          TotalCount: totalCount,
          Index: index
        };

        fd.append("chunkMetaData", JSON.stringify(metadata));

        const res = await apiFetch(`/api/EventPool/UploadEventPresentationChunks`, { method: "POST", body: fd });

        if (!res.ok) {
          const eText = await res.text();
          setError(eText || `File upload failed at chunk ${index + 1}/${totalCount}`);
          return;
        } else if (index === totalCount - 1) {
          // after last chunk is uploaded, update the existing row for the selected language
          const keys = [...(form.getValues("Keys") ?? [])];
          const targetLanguage = uploadingLanguage;
          const targetIndex = keys.findIndex((k) => k.Language === targetLanguage);

          if (targetIndex >= 0) {
            keys[targetIndex] = {
              ...keys[targetIndex],
              PathKey: fileGuid,
              TempFile: (await res.text()).replaceAll("\"", "").replaceAll("\\\\", "\\"),
              TOM: new Date().toISOString(),
            };
          } else {
            keys.push({ Language: targetLanguage, PathKey: fileGuid, TOM: new Date().toISOString() , TempFile: (await res.text()).replaceAll("\"", "").replaceAll("\\\\", "\\")} as any);
          }

          form.setValue("Keys", keys);
        }
      }

    

    } catch (err) {
      console.error(err);
      setError("File upload failed");
    } finally {
      setIsUploadingFile(false);
    }
  };

  type PresentationKey = NonNullable<z.infer<typeof PresentationSchema>["Keys"]>[number];




  const onSubmit = async (values: z.infer<typeof PresentationSchema>, event?: React.BaseSyntheticEvent) => {
  
   try{
      setError("");

      var keys = values.Keys ?? [];
      //check if any key has a TempFile property, if so, remove it and add the file to the form data
      const filesToUpload = keys.filter(k => k.TempFile);

    var sendValues = values;
    sendValues.Keys = null;
     
      const res = await apiFetch(`/api/eventpool/UpadteEventPresentation?key=${values.Id ?? 0}&values=${encodeURIComponent(JSON.stringify(sendValues))}`, {
        method: "POST"
      });

      if (!res.ok) {
        const e = await res.text();
        setError(e);
return;


      }
      else {
        var updatedId = values.Id ?? parseInt(await res.text());
        let hasError = false;
        // update keys and wait for each request before deciding whether to close
        for (const k of filesToUpload) {
          k.PresentationId = updatedId;
          const res = await apiFetch(`/api/eventpool/UpdateEventPresentationFiles?key=${k.Id ?? 0}&values=${encodeURIComponent(JSON.stringify(k))}`, {
            method: "POST"
          });

          if (!res.ok) {
            const e = await res.text();
            setError(e);
            hasError = true;
            break;
          }
        }

       if (!hasError)
          onClose(true);
        

      }
    } catch (err) {
      console.error(err);
    }
  }


  const DeleteFile = async (item: PresentationKey) => {
    try {
      setError("");

     

      const res = await apiFetch(`/api/EventPool/DeleteEventPresentationFiles?key=${item.Id}`, {
        method: "DELETE"
      });

      if (!res.ok) {
        const e = await res.text();
        setError(e);

      }
      else {

          const nextKeys: PresentationKey[] = (form.getValues("Keys") ?? []).filter(
            (k): k is PresentationKey => k.PathKey !== item.PathKey
          );
          form.setValue("Keys", nextKeys);

      }
    } catch (err) {
      console.error(err);
    }
  }
  const setFiles = (data: z.infer<typeof PresentationSchema>) => {
    const keys = [...(data.Keys ?? [])];

    langs.forEach((l) => {
      if (!keys.some((k) => k.Language === l)) {
        keys.push({ Language: l, PresentationId: data.Id} as any);
      }
    });

    form.reset({
      ...data,
      Keys: keys,
    });

  }
  useEffect(() => {

  if((Id??0)> 0)
    apiFetch(`/Admin/GetPresentation?id=${Id}`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch agenda group");
        return res.json();
      })
      .then((data) => {

        data.e.Keys = data.k as z.infer<typeof PresentationKeySchema>[];
        setFiles( data.e as z.infer<typeof PresentationSchema>);
        
         
        setIsLoaded(true);
        
      })
      .catch((err) => {
        console.error(err);
      });
      else
{
      setFiles(form.getValues());
      setIsLoaded(true);

}

  }, []);

const dateTimeFormatter = new Intl.DateTimeFormat("de-DE", {
  dateStyle: "short",
  timeStyle: "short",
});

function formatDateTime(value?: string | Date | null) {
  if (!value) return "-";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return dateTimeFormatter.format(date);
}


  return (
    <div className="p-5">
      {!isLoaded ? (
        <div>Loading…</div>
      ) : (
        <div>
          <input
            type="file"
            accept=".zip"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          <Form {...form}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation();
                void form.handleSubmit(onSubmit, (error) => {
                  console.log("Validation errors:", error, form.getValues());
                })(e);
              }}
              className="space-y-2"
            >

<div  className="flex gap-3 justify-start items-center">
               <FormField
                  control={form.control}
                  name="Title"
                  render={({ field }) => (
                    <FormItem className="flex-1">
                      <FormLabel>Title</FormLabel>
                      <FormControl>
                       <Input {...field} value={field.value ?? ""} />
                      </FormControl>
                    </FormItem>
                  )}
                />


            <FormField
                      control={form.control}
                      name={`PointerEvents`}
                      render={({ field }) => (
                        <FormItem >
                          <FormControl>
                            <Checkbox
                              label="Enable Pointer Events"
                              checked={!!field.value}
                              onCheckedChange={field.onChange}
                              name={field.name}
                              onBlur={field.onBlur}
                              ref={field.ref}
                              className="mt-3"
                            />
                          </FormControl>
                        </FormItem>
                      )}
                    />

</div>
<div className="text-lg font-semibold border-b border-slay-500">Files</div>
             
                 
                 <table className="w-full border-separate border-spacing-y-2">
                        {form.getValues("Keys")?.map((tab, index) => (
                          <tr
                            key={index}
                            className={"bg-slate-100" }
                          >
                           <td className="pl-2 font-bold">{tab.Language}</td>
                           <td><a className="text-blue-500 hover:underline" href={`${API_BASE_URL}/protected/${eventId}/Lectures/${tab.PathKey}/Index.html`} target="_blank" rel="noopener noreferrer">{tab.PathKey}</a></td>
                           <td>{formatDateTime(tab.TOM)}</td>
                           <td>{tab.PathKey && <Trash2 onClick={()=>DeleteFile(tab)}/>}</td>
                           <td><Button type="button" disabled={isUploadingFile} onClick={() => { setUploadingLanguage(tab.Language); fileInputRef.current?.click(); }}>Upload</Button></td>
                          </tr>
                        ))}
                     </table>
             
                   
                    



             


              <div className="grid-default">
                <div></div>
                <div className="grid-default">
                  <Button className="w-full" type="button" onClick={() => { console.log("Cancel clicked"); onClose(false); }}>Cancel</Button>

                  <Button className="w-full" type="submit" disabled={isUploadingFile}>Save</Button>
                </div>
              </div>
              {(errorText != "") && (
                <div className="text-red-500 mt-2">
                  {errorText}
                </div>
              )
              }
            </form>
          </Form>

        </div>)}




    </div>

  )
}



